import _extends from "/builds/unifygroup/uno/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends";
import React from "react";
var __jsx = React.createElement;
import { useMemo } from 'react';
import { useDropzone } from 'react-dropzone';
import { FormattedMessage } from 'react-intl';
import Loader from 'components/common/Loader';
import { DragIcon, DropzoneContainer, ErrorMessage } from './ImageDropzone.style';
import { useOnDrop } from './hooks/useOnDrop';
import { DropzoneStatus } from './type';

var ImageDropzone = function ImageDropzone(_ref) {
  var onImageDropped = _ref.onImageDropped,
      imageRatio = _ref.imageRatio,
      imageConstraints = _ref.imageConstraints;

  var _useOnDrop = useOnDrop({
    imageConstraints: imageConstraints,
    imageRatio: imageRatio,
    onImageDropped: onImageDropped
  }),
      onDrop = _useOnDrop.onDrop,
      constraintErrors = _useOnDrop.constraintErrors,
      loading = _useOnDrop.loading;

  var _useDropzone = useDropzone({
    accept: 'image/*',
    // Todo: fix this line, with an not async onDrop function
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    onDrop: onDrop,
    maxFiles: 1,
    multiple: false
  }),
      getRootProps = _useDropzone.getRootProps,
      getInputProps = _useDropzone.getInputProps,
      isDragActive = _useDropzone.isDragActive,
      isDragAccept = _useDropzone.isDragAccept,
      isDragReject = _useDropzone.isDragReject;

  var dropzoneStatus = useMemo(function () {
    switch (true) {
      case isDragReject:
        return DropzoneStatus.REJECT;

      case isDragAccept:
        return DropzoneStatus.ACCEPT;

      case isDragActive:
        return DropzoneStatus.ACTIVE;

      default:
        return DropzoneStatus.BASE;
    }
  }, [isDragActive, isDragReject, isDragAccept]);
  var validationMessages = constraintErrors.map(function (constraintError) {
    return __jsx(FormattedMessage, {
      id: constraintError.id,
      values: constraintError.values,
      tagName: ErrorMessage,
      key: constraintError.id
    });
  });
  return (// @ts-ignore HTMLElement is incompatible with HTMLDivElement
    __jsx(DropzoneContainer, _extends({
      status: dropzoneStatus
    }, getRootProps(), {
      ratio: imageRatio
    }), loading ? __jsx(Loader, null) : __jsx(React.Fragment, null, __jsx("input", getInputProps()), __jsx(DragIcon, null), validationMessages.length > 0 && validationMessages, isDragReject ? __jsx(FormattedMessage, {
      id: "image-modal.dropzoneDescription.reject",
      tagName: "p"
    }) : isDragActive || isDragAccept ? __jsx(FormattedMessage, {
      id: "image-modal.dropzoneDescription.active",
      tagName: "p"
    }) : __jsx(FormattedMessage, {
      id: "image-modal.dropzoneDescription.base",
      tagName: "p"
    })))
  );
};

export default ImageDropzone;